const mobileStickyBar = document.querySelector('.mobile-sticky-bar');

if (mobileStickyBar) {
  function showmobileStickyBar() {
    const endScreenOnScroll = document.body.offsetHeight - window.innerHeight * 1.2;
    if (document.documentElement.scrollTop < endScreenOnScroll) {
      mobileStickyBar.classList.add('active');
    } else {
      mobileStickyBar.classList.remove('active');
    }
  }

  showmobileStickyBar();
  window.addEventListener('scroll', showmobileStickyBar, { passive: true });
}

document.addEventListener('click', function (e) {
  const trigger = e.target.closest('[data-ds-mm-trigger]');
  if (!trigger) return;
  e.preventDefault();
  if (window.dsMobileMenu) {
    window.dsMobileMenu.open();
    return;
  }
  const menu = document.getElementById('ds-mobile-menu');
  if (menu) {
    menu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ds-mm-locked');
  }
});
